import React from 'react';

import {Add, CallMade} from '@material-ui/icons';

import {AppBar, Box, Grid, Typography} from '@material-ui/core';

import {Messages} from 'commons/constants';
import {AppBarStyles} from 'assets/tss/commons';
import {BottomContent, MainContent} from 'layouts/commons';
import {EfeButtonPrimary, EfeButtonSecondary} from 'components';

type Props = {
    moduleStep: boolean;
    authorization: boolean;
    handleSubmit: () => void;
    percentageCompleted: number;
    numberOfBeneficiaries: number;
    handleAddBeneficiary: () => void;
};

function BeneficiaryFooter(props: Props) {
    const classes = AppBarStyles();

    const {
        moduleStep,
        authorization,
        handleSubmit,
        percentageCompleted,
        numberOfBeneficiaries,
        handleAddBeneficiary,
    } = props;

    return (
        <BottomContent>
            <AppBar position='fixed' color='primary' className={classes.appBar}>
                <MainContent>
                    <Grid container direction='row' justifyContent='flex-start'>
                        <Grid item xs={12}>
                            <Box color='text.primary'>
                                <Typography variant='body2' color='textPrimary' align='justify'>
                                    <p>{Messages.BENEFICIARIES_FOOTER}</p>
                                    <p>{Messages.BENEFICIARIES_FOOTER_COMP}</p>
                                </Typography>
                            </Box>

                            <Box display='flex' flexDirection='row' justifyContent='center' m={2}>
                                <Grid item xs={12}>
                                    <Box m={2}>
                                        <EfeButtonSecondary
                                            fullWidth
                                            variant='outlined'
                                            onClick={handleAddBeneficiary}
                                            disabled={
                                                percentageCompleted >= 100 ||
                                                numberOfBeneficiaries > 5
                                            }
                                            endIcon={<Add />}>
                                            {'Agregar beneficiario'}
                                        </EfeButtonSecondary>
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box m={2}>
                                        <EfeButtonPrimary
                                            fullWidth
                                            onClick={handleSubmit}
                                            disabled={
                                                !moduleStep ||
                                                percentageCompleted * 1 < 100 ||
                                                !authorization
                                            }
                                            endIcon={<CallMade />}>
                                            {'Guardar y continuar'}
                                        </EfeButtonPrimary>
                                    </Box>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </MainContent>
            </AppBar>
        </BottomContent>
    );
}

export default BeneficiaryFooter;
